var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlertStock01 = function SvgAlertStock01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "alert_stock-01_svg2__a",
    x1: -13.45,
    x2: 154.27,
    y1: 159.66,
    y2: -4.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#alert_stock-01_svg2__a",
    id: "alert_stock-01_svg2__b",
    x1: 68.92,
    x2: 236.64,
    y1: 243.72,
    y2: 79.39
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#alert_stock-01_svg2__a",
    id: "alert_stock-01_svg2__c",
    x1: 55.62,
    x2: 223.33,
    y1: 230.15,
    y2: 65.82
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#alert_stock-01_svg2__a",
    id: "alert_stock-01_svg2__d",
    x1: 72.28,
    x2: 240,
    y1: 247.15,
    y2: 82.83
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M70.83 166.67H12.5a4.18 4.18 0 0 1-4.17-4.17v-150c0-2.3 1.88-4.17 4.17-4.17H50v62.5c0 1.58.89 3.02 2.3 3.72s3.1.56 4.37-.39L87.5 51.04l30.83 23.12c.73.55 1.62.83 2.5.83.63 0 1.28-.15 1.87-.44a4.17 4.17 0 0 0 2.3-3.72V8.33h37.5a4.18 4.18 0 0 1 4.17 4.17v100c0 2.3 1.87 4.17 4.17 4.17s4.17-1.87 4.17-4.17v-100c0-6.89-5.61-12.5-12.5-12.5H12.5C5.61 0 0 5.61 0 12.5v150c0 6.89 5.61 12.5 12.5 12.5h58.33c2.3 0 4.17-1.87 4.17-4.17s-1.87-4.17-4.17-4.17ZM116.67 8.33V62.5L90 42.5c-.74-.56-1.62-.83-2.5-.83s-1.76.28-2.5.83l-26.67 20V8.33h58.33Z",
    style: {
      fill: "url(#alert_stock-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m198.13 180.99-45.79-74.93c-2.18-3.73-6.28-6.06-10.68-6.06s-8.49 2.33-10.64 5.99l-45.73 74.85c-1.28 1.92-1.96 4.22-1.96 6.66 0 6.89 5.61 12.5 12.5 12.5h91.67c6.89 0 12.5-5.61 12.5-12.5 0-2.44-.67-4.74-1.87-6.51m-10.63 10.68H95.83a4.18 4.18 0 0 1-4.17-4.17c0-.78.18-1.48.64-2.16l45.88-75.07c.7-1.2 2.03-1.94 3.48-1.94s2.78.74 3.53 2.01l45.93 75.15c.36.53.54 1.23.54 2.01 0 2.3-1.88 4.17-4.17 4.17Z",
    style: {
      fill: "url(#alert_stock-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.67 125c-2.3 0-4.17 1.87-4.17 4.17v33.33c0 2.3 1.87 4.17 4.17 4.17s4.17-1.87 4.17-4.17v-33.33c0-2.3-1.87-4.17-4.17-4.17",
    style: {
      fill: "url(#alert_stock-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.25 175.33c-1.58-.67-3.41-.25-4.5.92-.83.75-1.24 1.83-1.24 2.92 0 .5.08 1.08.33 1.58.16.5.49 1 .91 1.33.33.42.83.75 1.33.92.5.25 1.08.33 1.58.33 1.08 0 2.17-.42 2.92-1.25.41-.33.74-.83.92-1.33.25-.5.33-1 .33-1.58 0-1.08-.41-2.17-1.25-2.92-.33-.42-.82-.75-1.33-.92",
    style: {
      fill: "url(#alert_stock-01_svg2__d)"
    }
  }));
};
export default SvgAlertStock01;